import {
  isNumeric,
  transformIntoObj,
  transformIntoObjArrays,
} from "../../utils/helpers.utils";
import * as DeliveryCommon from "../../utils/delivery-transforms.common";
import * as SharedTransform from "../../mocks/SharedTransform/response.transforms";
// Import these types directly for use in functions
import {
  ProductsDataTransform,
} from "../../utils/delivery-transforms.common";
import { getTimeSlotPayload } from "../../mocks/SharedTransform/response.transforms";

// Re-export common interfaces from the common utility
export type {
  MetaData,
  Name,
  Product,
  Address,
  ContactInfo,
  PosInformation,
  DeliverySlot,
  CustomerContactInfo,
  DeliveryInformation,
  PickUpContactInfo,
  PickupSlot,
  PickUpInformation,
  Reason,
  Order,
  CountryDetails,
  AssignedStatus,
  Vehicle,
  Driver,
  Route,
  Sort,
  Pageable,
  Sort2,
  Statuses,
  SubsProducts,
  ProductsDataTransform,
} from "../../utils/delivery-transforms.common";

// Module specific interfaces
export interface CarrefourProducts extends DeliveryCommon.Products {}

// Re-export common utility functions
export const getFilterAttributeValue = SharedTransform.getFilterAttributeValue;
export const getAddressInfo = DeliveryCommon.getAddressInfo;
export const getLatLong = DeliveryCommon.getLatLong;
export const createPublishRoutesPayload =
  DeliveryCommon.createPublishRoutesPayload;
export const createDeleteRoutePayload = DeliveryCommon.createDeleteRoutePayload;
export const createUpdateOrderStatusPayload =
  DeliveryCommon.createUpdateOrderStatusPayload;
export const getDiscardRoutePayload = DeliveryCommon.getDiscardRoutePayload;
export const createPayloadForUpdatingCustAddress =
  DeliveryCommon.createPayloadForUpdatingCustAddress;
export const getPlannedRoutesData = (routeData: any) =>
  DeliveryCommon.getPlannedRoutesData(routeData, true);
export const transformRouteConsignments =
  DeliveryCommon.transformRouteConsignments;
export const getAllAreasAndSlots = DeliveryCommon.getAllAreasAndSlots;
export const getDropdownsData = DeliveryCommon.getDropdownsData;
export const checkTerminalStatus = DeliveryCommon.checkTerminalStatus;
export const getConsignmentStatusField = DeliveryCommon.getConsignmentStatusField
export const getRouteStatusField = DeliveryCommon.getRouteStatusField;
export const CarrefourDeliveryOrdersDataTransform = DeliveryCommon.CarrefourOrdersDataTransform
export const CarrefourDeliveryRoutesDataTransform = DeliveryCommon.DeliveryRoutesDataTransform

export const createFilterPayload = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const basePayload = DeliveryCommon.createBaseFilterPayload(
    payload,
    data,
    isLoadMore
  );

  if (payload.deliveryProposition) {
    basePayload.attributes.push({
      key: payload.deliveryProposition.fieldName,
      value: ["CHD"],
    });
    delete basePayload.deliveryProposition;
  }

  basePayload.isCHD = true;
  return basePayload;
};

export const createPayloadForExcelExport = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const newPayload = createFilterPayload(payload, data, isLoadMore, isRoute);
  const orderFilterRequestDto = { orderFilterRequestDto: newPayload };
  return orderFilterRequestDto;
};

export const createRoutesPayloadForExcelExport = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const newPayload = createFilterPayload(payload, data, isLoadMore, isRoute);
  const routeFilterRequestDto = { routeFilterRequestDto: newPayload };
  return routeFilterRequestDto;
};

export const createGetAllPlannedRoutesPayload = (params: any) => {
    const basePayload = getTimeSlotPayload(params);
  return {
    ...basePayload,
    isCHD: true,
  };
};


export const rejectionDataTransform = (response: CarrefourProducts): any[] => {
  const transformedArray: any[] = [];
  response &&
    response.products &&
    response.products.forEach((product: ProductsDataTransform) => {
      const { sku, shippedQty, rejectedQty, name, unitPrice } = product;
      const qty = isNumeric(product.shippedQty)
        ? product.shippedQty
        : product.quantity;
      const isSubstitution = product.hasOwnProperty("substitutedProducts");
      const isScalable = product.uom?.toLowerCase() === "grams";
      const totalQty = isScalable
        ? 1
        : isSubstitution
        ? product.substitutedProducts[0].shippedQty
        : +qty;
      const rejectedItems = isSubstitution
        ? +product.substitutedProducts[0].rejectedQty || 0
        : +product.rejectedQty || 0;
      const initialQty = isScalable
        ? rejectedItems > 0
          ? 1
          : 0
        : rejectedItems;
      let newObj: any = [];
      let selectRejected = [];
      for (let i = 0; i <= Number(totalQty); i++) {
        newObj = transformIntoObjArrays(i, totalQty);
      }
      selectRejected = transformIntoObj(initialQty);
      const deliveryReason = [];
      if (product.reason) {
        deliveryReason.push({
          name: product.reason.reasonDescription,
          value: product.reason.reasonCode,
        });
      } else {
        if (product.substitutedProducts) {
          product.substitutedProducts.forEach((subProd: any) => {
            if (subProd.reason) {
              deliveryReason.push({
                name: subProd.reason.reasonDescription,
                value: subProd.reason.reasonCode,
              });
            }
          });
        }
      }
      transformedArray.push({
        id: sku,
        name: name,
        shippedQty: shippedQty || 0,
        rejectedQty: rejectedQty || 0,
        unitPrice: unitPrice,
        totalQty: totalQty,
        rejectedQtyList: newObj,
        selectedRejectedQty: selectRejected,
        itemDeliveryReason: deliveryReason,
        substitutedProducts: product.substitutedProducts,
      });
    });
  return [...transformedArray];
};

